import { Injectable, Type } from '@angular/core';

import {
  BautagebuchDialogData,
  BautagebuchWorkspaceKey
} from '../models/bautagebuch-dialog-data.model';
import { BauherrDashboardWorkspaceComponent } from '../workspaces/bauherr-dashboard-workspace/bauherr-dashboard-workspace.component';
import { BautagebuchGuWorkspaceComponent } from '../workspaces/bautagebuch-gu-workspace/bautagebuch-gu-workspace.component';
import { TagesberichtNuWorkspaceComponent } from '../workspaces/tagesbericht-nu-workspace/tagesbericht-nu-workspace.component';

export interface BautagebuchWorkspaceRegistration {
  key: BautagebuchWorkspaceKey;
  title: string;
  component: Type<unknown>;
}

@Injectable({
  providedIn: 'root'
})
export class BautagebuchWorkspaceRegistryService {
  private readonly registrations: Record<BautagebuchWorkspaceKey, BautagebuchWorkspaceRegistration> = {
    'tagesbericht-nu': {
      key: 'tagesbericht-nu',
      title: 'Tagesbericht (Nachunternehmer)',
      component: TagesberichtNuWorkspaceComponent
    },
    'bautagebuch-gu': {
      key: 'bautagebuch-gu',
      title: 'Bautagebuch',
      component: BautagebuchGuWorkspaceComponent
    },
    'bauherr-dashboard': {
      key: 'bauherr-dashboard',
      title: 'Bauherr Dashboard',
      component: BauherrDashboardWorkspaceComponent
    }
  };

  resolve(data: BautagebuchDialogData): BautagebuchWorkspaceRegistration {
    return this.registrations[data.workspaceKey];
  }
}
